export function AIBanner() {
    // Check if already dismissed
    if (localStorage.getItem('ai_act_accepted')) {
        return null;
    }

    const banner = document.createElement('div');
    banner.className = "fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-96 bg-white rounded-2xl shadow-2xl border border-brand-primary/20 p-5 z-[100] animate-fade-in-up flex flex-col gap-3 transition-all duration-300";
    banner.id = "ai-transparency-banner";

    banner.innerHTML = `
        <div class="flex items-start gap-3">
            <div class="text-2xl mt-1">🤖</div>
            <div class="flex-1">
                <h4 class="font-heading font-bold text-brand-primary text-sm mb-1">Trasparenza AI (EU AI Act)</h4>
                <p class="text-xs text-text-muted leading-relaxed">
                    Questa piattaforma fa uso di sistemi di Intelligenza Artificiale per generare narrazioni, voci o raccomandazioni culturali. 
                    <a href="#" id="ai-banner-policy-link" class="text-brand-secondary underline hover:text-brand-accent transition-colors">Scopri di più nella nostra Policy</a>.
                </p>
            </div>
        </div>
        <button id="ai-banner-accept" class="w-full bg-brand-primary text-white text-sm font-bold py-2.5 rounded-xl hover:bg-brand-secondary transition-all shadow-sm active:scale-95">
            Ho capito
        </button>
    `;

    setTimeout(() => {
        const acceptBtn = banner.querySelector('#ai-banner-accept');
        const policyLink = banner.querySelector('#ai-banner-policy-link');

        if (acceptBtn) {
            acceptBtn.onclick = () => {
                localStorage.setItem('ai_act_accepted', 'true');
                banner.classList.add('opacity-0', 'translate-y-4'); // fade out animation
                setTimeout(() => banner.remove(), 300); // remove after animation
            };
        }

        if (policyLink) {
            policyLink.onclick = (e) => {
                e.preventDefault();
                window.dispatchEvent(new CustomEvent('navigate', { detail: 'privacy' }));
                banner.classList.add('opacity-0', 'translate-y-4');
                setTimeout(() => banner.remove(), 300);
            };
        }
    }, 0);

    return banner;
}
